export type CsvColumn<T> = {
    header: string;
    read: (row: T) => string | number | boolean | null | undefined;
};

const escapeCell = (value: string | number | boolean | null | undefined) => {
    const text = value === null || value === undefined ? "" : String(value);

    return /[";\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

/** Excel reads a semicolon-separated file in a french locale, where a comma is a decimal mark. */
const SEPARATOR = ";";

export const toCsv = <T>(rows: T[], columns: CsvColumn<T>[]): string =>
    [
        columns.map(({ header }) => escapeCell(header)).join(SEPARATOR),
        ...rows.map(row => columns.map(({ read }) => escapeCell(read(row))).join(SEPARATOR)),
    ].join("\r\n");
